import { useState } from "react";

export default function BeforeAfterSlider({ before, after, beforeLabel = "Before", afterLabel = "After", beforeAlt, afterAlt }) {
  const [pos, setPos] = useState(50);
  const clip = 100 - pos;
  return (
    <div className="ba-wrap aspect-[4/3] md:aspect-[16/10] rounded-sm border border-white/10" style={{"--ba-clip": `${clip}%`}} data-testid="before-after-slider">
      <img src={before} alt={beforeAlt || `${beforeLabel} — original space before architectural wrap installation by Toronto Custom Signs & Wraps`} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
      <div className="ba-after">
        <img src={after} alt={afterAlt || `${afterLabel} — completed architectural wrap installation by Toronto Custom Signs & Wraps`} loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="ba-handle" />
      <div className="ba-thumb" aria-hidden>⇆</div>
      <span className="ba-label left-4">{beforeLabel}</span>
      <span className="ba-label right-4">{afterLabel}</span>
      <input
        type="range"
        min="5"
        max="95"
        value={pos}
        onChange={(e) => setPos(parseInt(e.target.value))}
        className="ba-range"
        aria-label="Before-after slider"
        data-testid="ba-range-input"
      />
    </div>
  );
}
